import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Edit, Plus } from 'react-feather';

import PostCredentialForm, {
  PostCredentialFormWithModal,
} from 'app/components/profile/PostCredentialForm';
import ProfileCredentialIcon from 'app/components/profile/ProfileCredentialIcon';

import {
  openPostCredentialModal,
  closePostCredentialModal,
} from 'app/dispatcher/modalDispatcher';
import { generateCredentialText } from 'app/utils/formatCredentials';

const CredentialItem = props => {
  const { credential, handleEditClick, value, onChange, withCheckbox } = props;
  if (!credential) return null;
  const { id, credentialType, isDefault } = credential;

  return (
    <div className="flex justify-between w-full items-center gap-4">
      {withCheckbox && (
        <div className="flex gap-4 items-center mr-6">
          <input
            type="checkbox"
            name="credentialId"
            checked={value === id}
            onChange={() => onChange(id)}
          />
        </div>
      )}
      <div className="flex gap-4 items-center">
        <ProfileCredentialIcon credentialType={credentialType} />
        {generateCredentialText(credential)}
        <span className="text-neutral-500 ml-4">
          {isDefault && '(default)'}
        </span>
      </div>
      <Edit
        className="cursor-pointer mr-2 text-neutral-500"
        size={17}
        onClick={() => handleEditClick(credential)}
      />
    </div>
  );
};

const ProfileCredentialsInputRow = props => {
  const {
    credentials,
    renderCredentialWithModal,
    withoutFormLabel,
    withCheckbox,
    value,
    onChange,
  } = props;

  const dispatch = useDispatch();

  // State
  const [isCredentialFormOpen, setIsCredentialFormOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editedCredential, setEditedCredential] = useState({});

  const handleEditClick = credential => {
    if (isCredentialFormOpen) return;

    // if it is mobile, open modal
    if (renderCredentialWithModal) {
      dispatch(openPostCredentialModal());
    } else {
      setIsCredentialFormOpen(true);
    }

    setIsEdit(true);
    setEditedCredential(credential);
  };

  const resetForm = () => {
    if (renderCredentialWithModal) {
      dispatch(closePostCredentialModal());
    } else {
      setIsCredentialFormOpen(false);
    }
    setIsEdit(false);
    setEditedCredential({});
  };

  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:justify-between justify-start w-full">
      {!withoutFormLabel && (
        <div className="flex lg:w-[130px] w-auto">
          <p className="text-sm font-bold">Credential</p>
        </div>
      )}
      <div className="flex flex-col gap-6 w-full">
        {credentials.map((credential, index) => (
          <CredentialItem
            handleEditClick={handleEditClick}
            credential={credential}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            withCheckbox={withCheckbox}
            value={value}
            onChange={onChange}
          />
        ))}
        {isCredentialFormOpen && (
          <div className="flex flex-col gap-4 w-full items-baseline">
            <div className="horizontal-divider" />
            <PostCredentialForm
              isEdit={isEdit}
              editedCredential={editedCredential}
              resetForm={resetForm}
            />
          </div>
        )}
        <PostCredentialFormWithModal
          isEdit={isEdit}
          editedCredential={editedCredential}
          resetForm={resetForm}
        />
        {!isCredentialFormOpen && (
          <div
            className="flex cursor-pointer gap-1 items-center"
            onClick={() => {
              if (renderCredentialWithModal) {
                dispatch(openPostCredentialModal());
              } else {
                setIsCredentialFormOpen(true);
              }
            }}
          >
            <Plus className="text-blue-500" size={22} />
            <p className="text-blue-500">Add Credential</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileCredentialsInputRow;
